import Api from 'api/api';
import { queryKeys } from 'api/queryKeys';

export const registryPersons = {
  queryKey: queryKeys.registryPersons,
  queryFn: Api.getRegistryPersons,
};
